const storageHelper = {
  // Create/Update - Set data in localStorage
  set: (key, value) => {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
      return true;
    } catch (error) {
      console.error('Error saving to localStorage:', error);
      return false;
    }
  },

  // Read - Get data from localStorage
  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error('Error reading from localStorage:', error);
      return null;
    }
  },

  // Delete - Remove specific data from localStorage
  remove: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error removing from localStorage:', error);
      return false;
    }
  },

  // Delete all - Clear all data from localStorage
  clear: () => {
    try {
      localStorage.clear();
      return true;
    } catch (error) {
      console.error('Error clearing localStorage:', error);
      return false;
    }
  },

  // Check if key exists
  exists: (key) => {
    return localStorage.getItem(key) !== null;
  },

  // Update specific field in an object
  updateField: (key, field, value) => {
    try {
      const item = storageHelper.get(key);
      if (item && typeof item === 'object') {
        item[field] = value;
        return storageHelper.set(key, item);
      }
      return false;
    } catch (error) {
      console.error('Error updating field in localStorage:', error);
      return false;
    }
  }
};

export default storageHelper;
